const years = Array.from(Array(new Date().getFullYear() - 1949), (_, i) => i + 1950).reverse();

export default years;
